/*
 * @创建文件时间: 2019-11-10 11:24:29
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-15 16:06:52
 * @联系Qq:1638245306
 * @文件介绍: 
 */
import Vue from 'vue'
import d2Container from './d2-container'
import d2ContainerFrame from './d2-container-frame'

//动态表单和表格
import dynamicForm from './DynamicPages/Form/DynamicForm'
import dynamicTable from './DynamicPages/Tables/DynamicTable'
import dynamicTree from './DynamicPages/Tables/DynamicTree'
//分割线
import divider from './aboutForm/divider'
// dialogForm
import dialogForm from './aboutForm/dialogForm'
// popoverForm
import popoverForm from './aboutForm/popoverForm'
// 制单人信息
import billingInfo from './aboutForm/billingInfo'
// 树形菜单table
import treeTable from './DynamicPages/Tables/DynamicTreeTable'
//弹窗树形
import dialogTree from './aboutForm/dialogTree'
//echarts工具
import echartsTools from './EchartTools/index'
import assessCharts from './EchartTools/assessCharts'
//文件上传
import dialogFile from './DynamicPages/Customize/DialogFile'
import dialogImg from './DynamicPages/Customize/DialogImg'
//文件导入
import dialogUploadFile from './DynamicPages/Customize/DialogUploadFile'
//quill富文本
import d2Quill from './d2-quill'
//视频图片展示
import imgVideo from './aboutForm/imgVideo'
//国家桥梁导入
import UploadBrige from "@/components/DynamicPages/Customize/UploadBrige";

// 注意 有些组件使用异步加载会有影响
Vue.component('d2-container', d2Container)
Vue.component('d2-container-frame', d2ContainerFrame)
Vue.component('d2-icon', () =>
    import ('./d2-icon'))
Vue.component('d2-icon-svg', () =>
    import ('./d2-icon-svg/index.vue'))
Vue.component('d2-icon-select', () =>
    import ('./d2-icon-select/index.vue'))
Vue.component('dynamicForm', dynamicForm)
Vue.component('dynamicTable', dynamicTable)
Vue.component('divider', divider)
Vue.component('dialogForm', dialogForm)
Vue.component('popoverForm', popoverForm)
Vue.component('billingInfo', billingInfo)
Vue.component('treeTable', treeTable)
Vue.component('dynamicTree', dynamicTree)
Vue.component('dialogTree', dialogTree)
Vue.component('echartsTools', echartsTools)
Vue.component('assessCharts', assessCharts)
Vue.component('dialogFile', dialogFile)
Vue.component('dialogImg', dialogImg)
Vue.component('dialogUploadFile', dialogUploadFile)
Vue.component('d2-quill', d2Quill)
Vue.component('imgVideo', imgVideo)
Vue.component('uploadBrige', UploadBrige)